import { compose, filter, groupBy, indexBy, map, prop } from 'ramda';
import { FIELD_COMPONENT_TYPE } from "../../../Manifest/modules/editableComponentTypes";

// EditableComponent -> Boolean
const isMaxLengthComponent = ({ component, maxLength, fullItem }) =>
    component === FIELD_COMPONENT_TYPE &&
    (typeof maxLength) === 'number' &&
    (typeof fullItem) === 'string';

const leafNamePattern = /.*\/(?:@)?(?:[^/]+:)?([^/]+)$/;

// CharacterLimit -> String
const getLeafName = ({ xpath }) => xpath.replace(leafNamePattern, '$1');

// EditableComponent -> CharacterLimit
export const editableComponentToCharacterLimit = ({ fullItem, viewContext, maxLength }) => ({
    xpath: fullItem,
    ctrlid: viewContext,
    maxLength,
});

// [EditableComponent] -> [CharacterLimit]
export const getCharacterLimits = compose(
    map(editableComponentToCharacterLimit),
    filter(isMaxLengthComponent)
);

// [CharacterLimit] -> { String: [CharacterLimit] }
const groupByLeafName = compose(
    groupBy(getLeafName),
    filter(prop('xpath')),
);

// [CharacterLimit] -> { String: CharacterLimit }
const indexByCtrlId = compose(
    indexBy(prop('ctrlid')),
    filter(prop('ctrlid'))
);

export const makeCharacterLimitMap = (characterLimits) => ({
    byFieldName: groupByLeafName(characterLimits),
    byCtrlId: indexByCtrlId(characterLimits),
});